import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-6 md:text-2xl text-lg font-medium text-neutral-600" }
const _hoisted_2 = { class: "md:inline-block block font-semibold text-neutral-900" }
const _hoisted_3 = { class: "w-full lg:p-6 p-4 mx-auto my-6 border border-gray-200 rounded" }
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = { class: "grid grid-cols-6 gap-6 mt-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 border-t border-gray-200" }, null, -1)
const _hoisted_7 = { class: "col-span-6" }
const _hoisted_8 = { class: "flex flex-1 md:space-x-6 md:space-y-0 space-y-3 md:flex-row flex-col" }
const _hoisted_9 = { class: "md:w-1/3 w-full" }
const _hoisted_10 = { class: "md:w-1/3 w-full" }
const _hoisted_11 = { class: "md:w-1/3 w-full" }
const _hoisted_12 = { class: "shrink-0 md:pt-[26px] pt-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Search", -1)

import { computed, ref } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import { useRouter, useRoute } from "vue-router";
import { PerpetratorSearch } from "@/interfaces/Cases/Perpetrator";
import { errorResponse } from "@/helpers/errorMessage"; 
import pickBy from "lodash/pickBy"; 
import { onIonViewWillEnter } from "@ionic/vue";
import SearchTwoIcon from "@/components/icons/searchTwoIcon.vue";
import Rules from "@/classes/Patients/Offline/Validation/Rules";
import useVuelidate from "@vuelidate/core";
import ErrorValidation from "@/views/interventions/Components/Classess/ErrorValidation";
import { useNetworkStore } from "@/store/network";
import PerpetratorService from "@/classes/Perpetrators/PerpetratorService";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const errors = ref<object>({});
const patientId = ref<number | null>(route.params.patient);
const caseId = ref<number | null>(route.params.case);
const form = ref<PerpetratorSearch>({
	last_name: null,
	first_name: null,
	birthdate: null,
});
const patient = ref<string>('');
const { searchRules } = Rules;
const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

const getData = async (): Promise<any> =>{
	await PerpetratorService.getPatient(
		patientId.value,
		caseId.value,
        isNetworkAvailable.value,
	)
		.then(({data}) => {
            console.log(data, 'dadasd')
			patient.value = data.patient
		})
		.catch((error: object) => {
			errors.value = errorResponse(error.response?.data?.errors);
		});
}

/**
 * Validate the form using Vuelidator
 */
 const validateForm = async () =>{
	const vuelidate = useVuelidate(searchRules({...form.value}), form.value)
	const result = await vuelidate.value.$validate();

    if (result) {
        return null;
    } else {
        errors.value = ErrorValidation.getErrors(vuelidate.value);
        errorResponse(errors.value);
        return errors.value;
    }
}

const search = async (): void => {
    errors.value = {};

    // Set validation rule for Online and Offline
    const validate = await validateForm();
    if (validate) {
        return;
    }

    const response = await PerpetratorService.index(
		patientId.value,
		caseId.value,
		{ ...form.value },
        isNetworkAvailable.value
	)

    if (response?.status === 200 || response?.data != undefined) {
        router.push({
				path: `/patient/${patientId.value}/cases/${caseId.value}/perpetrators/index`,
				query: form.value,
			});
    } else {
        const error = response;
        errors.value = errorResponse(error.response?.data?.errors);
    }
};

const resetForm = () => {
    form.value.last_name = null;
    form.value.first_name = null;
    form.value.birthdate = null;
}
 
onIonViewWillEnter(async () => {
    resetForm(); 
    await getData();
}); 

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backLink: `/patient/${patientId.value}/cases/${caseId.value}/edit`,
    backTitle: "Search Perpetrator"
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, [
        _createTextVNode("Patient's Name: "),
        _createElementVNode("span", _hoisted_2, _toDisplayString(patient.value), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(SectionTitle, { title: "Search Perpetrator" })
        ]),
        _createElementVNode("form", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "First Name",
                  placeholder: "First name",
                  name: "first_name",
                  id: "first_name",
                  modelValue: form.value.first_name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.first_name) = $event)),
                  error: errors.value?.first_name
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Last Name",
                  placeholder: "Last name",
                  name: "last_name",
                  id: "last_name",
                  modelValue: form.value.last_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.last_name) = $event)),
                  error: errors.value?.last_name
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(DatePicker, {
                  id: "birthdate",
                  name: "birthdate",
                  label: "Birthdate",
                  modelValue: form.value.birthdate,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.birthdate) = $event)),
                  error: errors.value?.birthdate
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(ButtonComponent, {
                  customClass: "quaternary md:w-auto w-full",
                  size: "large",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (search()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(SearchTwoIcon, { class: "object-contain w-5 h-5 mr-1 icon" }),
                    _hoisted_13
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["backLink"]))
}
}

})